var map = {
	"./about.js": "9cbf",
	"./academic-year.js": "382c",
	"./approval-work-flow.js": "4620",
	"./attendance-device.js": "4bab",
	"./attendance-setting.js": "201d",
	"./attendance-shift.js": "46fa",
	"./bank-profile.js": "5604",
	"./branch.js": "6d83d",
	"./building.js": "d9e8",
	"./calendar.js": "bfe0",
	"./campus-attendance.js": "9fae",
	"./car-attendance-history.js": "caa5",
	"./car-attendance.js": "8c8a",
	"./cardToBePrint/all-profile.js": "33cf",
	"./cardToBePrint/existing-profile.js": "83de",
	"./cardToBePrint/new-profile.js": "12cf",
	"./category.js": "d0c1",
	"./class-attendance.js": "39eb",
	"./class-operation.js": "18c9",
	"./class-teaching.js": "439d",
	"./company.js": "c8cb",
	"./corporate-partner.js": "659e",
	"./dashboard.js": "76b5",
	"./default-credit-day.js": "ff8c",
	"./department.js": "0b2f",
	"./division.js": "7d9c",
	"./employee-card-activator.js": "907c",
	"./employee-daily-timescan.js": "2d6f",
	"./employee.js": "8b4f",
	"./eschool/e-exam/catalog.js": "95e3",
	"./eschool/e-exam/question.js": "f9b8",
	"./eschool/homework-comment-private.js": "54e1",
	"./eschool/homework-comment-public.js": "bb53",
	"./eschool/homework-correction.js": "bb77",
	"./eschool/parent-homework.js": "7b9b",
	"./eschool/staff-homework.js": "bf3a",
	"./eschool/student-homework.js": "f185",
	"./eschool/teacher-homework.js": "04b6",
	"./event.js": "daf6",
	"./exam-schedule.js": "6ec1",
	"./exchange-rate.js": "9eac",
	"./fee-group.js": "4032",
	"./fee-setup.js": "a258",
	"./fee-type.js": "9d7e",
	"./file-manager/file-browser.js": "a19e",
	"./file-manager/file-function.js": "9227",
	"./front-cover.js": "db36",
	"./generate-total-score.js": "cc9c",
	"./grade.js": "f54e",
	"./grading-definition.js": "9c25",
	"./group-chat-responsible.js": "a4d5",
	"./history-tracking.js": "e3d0",
	"./holiday-rule.js": "e4dc1",
	"./holiday.js": "ccc4",
	"./home/notification-history.js": "29f32",
	"./home/parent-homework-link-from-home.js": "693a",
	"./home/parent-homework.js": "33f5",
	"./home/parent-my-request.js": "ea18",
	"./home/parent-notification-history.js": "93b2",
	"./home/parent-payment-history.js": "1985",
	"./home/parent-request-link-from-home.js": "1aa5",
	"./home/parent.js": "910c",
	"./home/payment-history.js": "515f",
	"./home/staff-homework-link-from-home.js": "8238",
	"./home/staff-homework.js": "6f3a",
	"./home/staff-my-approval.js": "ac79",
	"./home/staff-my-request.js": "b4dd",
	"./home/staff.js": "955d",
	"./home/student-homework-link-from-home.js": "3d32",
	"./home/student-homework.js": "b295",
	"./home/student-my-request.js": "e672",
	"./home/student-notification-history.js": "22e7",
	"./home/student-payment-history.js": "d5ac",
	"./home/student-request-link-from-home.js": "01b2",
	"./home/student.js": "d44f",
	"./home/teacher-homework-link-from-home.js": "b413",
	"./home/teacher-homework.js": "18ec",
	"./home/teacher-my-request.js": "a223",
	"./home/teacher-notification-history.js": "fdd2",
	"./home/teacher.js": "466f",
	"./index.js": "2a74",
	"./info-inquiry.js": "a2d7",
	"./inventory-list.js": "a9c1",
	"./invoice-confirm.js": "972a",
	"./invoice.js": "fe93",
	"./khmer-secondary-schedule.js": "6b07",
	"./leave-record.js": "0a3ce",
	"./level.js": "3547",
	"./location-settlement.js": "3cd9",
	"./main-program.js": "418f",
	"./new-student-unpaid.js": "e5fa",
	"./news.js": "611b",
	"./notification-history.js": "674e",
	"./notification-manual.js": "3dd1",
	"./notification-monitoring.js": "f2ff",
	"./notification-schedule.js": "7162",
	"./notification-template.js": "590b",
	"./parent-communication-chat.js": "f8e2",
	"./parent-profile.js": "a16b",
	"./payment-adjustment.js": "4601",
	"./payment-announcement.js": "6931",
	"./payment-testing.js": "a64b",
	"./pickup-card-activator.js": "5b24",
	"./pickup-card-creation.js": "6ac1",
	"./pickup-display.js": "4c2c",
	"./pickup-history.js": "3c6f",
	"./position.js": "76e2",
	"./pre-invoice.js": "3b6e",
	"./product-location.js": "fa9a",
	"./product-movement.js": "0d27",
	"./product.js": "c2ff",
	"./promotion.js": "8912",
	"./purchase-order.js": "fd9b",
	"./receipt.js": "320a",
	"./report-academic.js": "fad4",
	"./report-inventory.js": "391c",
	"./report-payment.js": "9420",
	"./reset-device-password.js": "b1d3",
	"./retail-sale.js": "9d41",
	"./role.js": "d409",
	"./room.js": "a8d9",
	"./schedule-time.js": "1084",
	"./schedule.js": "e4b3",
	"./scholarship.js": "37a7",
	"./school-contact.js": "d656",
	"./score-assessment.js": "93e9",
	"./score-component.js": "e375",
	"./service-subscription.js": "1202",
	"./setup-landing-page.js": "3154",
	"./signature.js": "f894",
	"./staff-student-gallery.js": "605b",
	"./stock-adjustment.js": "4000",
	"./stock-count-entry.js": "8183",
	"./stock-in.js": "def9",
	"./stock-transfer.js": "cbc8",
	"./student-card-activator.js": "8ef8",
	"./student-enrollment.js": "e677",
	"./student-follow-up.js": "d7f1",
	"./student-health.js": "9bc8",
	"./student-invoice.js": "0f33",
	"./student-profile.js": "131c",
	"./student-scoring-component-entry.js": "9074",
	"./student-scoring-entry.js": "bb64",
	"./student-transfer.js": "3bbe",
	"./study-time.js": "cc2f",
	"./sub-program.js": "6790",
	"./subject-activity.js": "3f51",
	"./subject-core.js": "4f53",
	"./subject-elective.js": "d693",
	"./subject-grading-range.js": "43f2",
	"./supplier.js": "3ed8",
	"./teacher-subject-code.js": "ed86",
	"./teacherProfile.js": "7712",
	"./term-semester.js": "1845",
	"./total-score-grading-range.js": "acd8",
	"./transportation-distance.js": "85d2",
	"./transportation-way.js": "7ddb",
	"./uom-category.js": "0756",
	"./user.js": "0f9a",
	"./vehicle-operation.js": "38c0",
	"./vehicle-profile.js": "65f6",
	"./vehicle-zone-profile.js": "3089",
	"./warehouse.js": "efa0",
	"./work-schedule.js": "1c62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0308";